var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranscriptMerge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 725 l-85 -85 68 0 67 0 0 -112 0 -113 -107 -107 -108 -108 28 -27 27 -28 120 120 120 120 0 127 0 128 67 0 68 0 -85 85 c-47 47 -87 85 -90 85 -3 0 -43 -38 -90 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 305 l-24 -26 67 -67 67 -67 27 28 27 27 -64 65 c-35 36 -67 65 -70 65 -4 0 -17 -11 -30 -25z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscriptMerge);
export default __webpack_public_path__ + "static/media/transcript-merge.c3a7142e.svg";
export { ForwardRef as ReactComponent };